import React from 'react';
import { List } from "semantic-ui-react";
import parseServerChangeLog from './parseServerLog'

class ParametrizedEmailSentDetails extends React.Component {
  render() {
    const {
      details
    } = this.props

    const data = parseServerChangeLog(details).data
    return (
      <List size='small'>
        {this.renderList(data)}
      </List>
    )
  }

  renderList = (item) => {
    switch(Object.prototype.toString.call(item)) {
      case '[object Array]':
        return item.map((itemInsideArray, index) => {
          return (
            <List.Item key={`${itemInsideArray} ${index}`}>
              <List.Content style={{paddingLeft:'1em'}}>
                <b>{index}:</b>
                <List.Item>
                  <List.Content style={{paddingLeft:'1em'}}>
                    {this.renderList(itemInsideArray)}
                  </List.Content>
                </List.Item>
              </List.Content>
            </List.Item>
          )
        })
      case '[object Object]':
        const objectKeys = Object.keys(item)
        const objectValues = Object.values(item)
        return objectKeys.map((key, index) => {
          return (
            <List.Item key={`${item} ${index}`}>
              <List.Content>
                <b>{key}:</b> {this.renderList(objectValues[index])}
              </List.Content>
            </List.Item>
          )
        })
      default:
        return item
    }
  }
}

export default ParametrizedEmailSentDetails



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimHistory/HistoryItem/ActionTypes/ParametrizedEmailSentDetails.js